import { css, html } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { property } from "lit/decorators/property.js";
import { BsCard } from "./card";
import "./title";
import "./form-item";
import "./rainbow-border";
import { getStarted } from "../util/landing-util";
import { Size } from "shared";

@customElement("bs-blog-get-started-card")
export class BsBlogGetStartedCard extends BsCard {
	static get styles() {
		return [
			...super.styles,
			css`
				:host {
					position: relative;
				}

				#content {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					gap: var(--space-m);
					text-align: center;

					position: relative;
					z-index: 2;
					background: var(--background);
					border-radius: inherit;
				}
			`
		];
	}

	@property({ type: String }) text: string = "Your ideas, at their best.";
	@property({ type: String }) cta: string = "Get Ideamap — it's free";
	@property({ type: String, reflect: true }) size: Size = "large";

	render() {
		const { text, cta } = this;
		return html`
			<div id="content">
				<bs-title size="large">${text}</bs-title>
				<bs-form-item size="large">
					<button slot="input" @click="${() => getStarted("blog")}">${cta}</button>
				</bs-form-item>
			</div>
			<bs-rainbow-border></bs-rainbow-border>
		`;
	}
}
